module.exports = __webpack_public_path__ + "img/block_bg_7.df014448.png";